import { cloneDeep } from "lodash";
import { NodeEditor } from "rete/types/editor";

import { CustomNode } from "../Nodes";
import FlowCommand from "./FlowCommand";

class NodeCommand extends FlowCommand {
  editor: NodeEditor;
  node: CustomNode

  constructor(editor: NodeEditor, node: CustomNode) {
    super();

    this.editor = editor;
    this.node = node;
  }
}

export class AddNodeCommand extends NodeCommand {
  undo() {
    this.editor.removeNode(this.node)
  }

  redo() {
    this.editor.addNode(this.node)
  }
}

export class RemoveNodeCommand extends NodeCommand {
  undo() {
    this.editor.addNode(this.node)
  }

  redo() {
    this.editor.removeNode(this.node)
  }
}

export class NodeTranslateCommand extends NodeCommand {
  oldPos: [ number, number ]
  newPos: [ number, number ]

  constructor(editor: NodeEditor, node: CustomNode, prevPos: [number, number]) {
    super(editor, node)

    this.oldPos = [ ...node.position ]
    this.newPos = [ ...prevPos ]
  }

  private translateTo(position: [ number, number ]) {
    const node = this.editor.view.nodes.get(this.node)

    if (node) {
      node.translate(...position);
    }
  }

  undo() {
    this.translateTo(this.oldPos)
  }

  redo() {
    this.translateTo(this.newPos)
  }
}
